import { render, staticRenderFns } from "./Tour.vue?vue&type=template&id=6d871180&"
import script from "./Tour.vue?vue&type=script&lang=ts&"
export * from "./Tour.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports